/* ==========================================================================
   Searcher > Client > Origin
   ========================================================================== */

/* Modules */
const selectActions = require('../../../../select-panel/client/js/store/actions');
const SelectClient = require('../../../../select-panel/client/js');

const { setSelectOptions } = require('../services');
const { vaidateOrigin } = require('../validations');

const configuration = require('../config');

function initOrigin(instance) {
    const inst = instance;
    const { selector } = instance;

    /* Init origin */
    inst.origin = SelectClient(
        `${selector} [data-component="SelectPanel"][data-type="${configuration().type.origin}"]`
    );

    if (!inst.origin) return;

    /* Extend reactions */
    inst.reactions = {
        ...inst.reactions,
        openOrigin: inst.origin.store.subscribe((state, action) => {
            if (action.type !== selectActions.types.OPEN_PANEL) return;

            inst.actions.openPanel('origin');
        }),
        closeOrigin: inst.origin.store.subscribe((state, action) => {
            if (action.type !== selectActions.types.CLOSE_PANEL) return;

            inst.actions.closePanel('origin');
        }),
        changeOrigin: inst.origin.store.subscribe((state, action) => {
            if (action.type !== selectActions.types.CHANGE_VALUE && action.type !== selectActions.types.CHANGE_OPTIONS)
                return;

            /* Data store */
            const { value: originValue } = instance.origin.store.select('data');

            if (originValue !== null && originValue !== undefined) instance.actions.changeData({ origin: originValue });

            /* Validate */
            vaidateOrigin(instance);

            /* Set new choices for destination */
            if (instance.destination && originValue !== undefined && originValue !== null) {
                setSelectOptions(instance, 'destination', originValue);
            }
        })
    };

    /* Set new choices select origin */
    setSelectOptions(inst, 'origin');
}

/* Exports */
module.exports = {
    initOrigin
};
